import { useCallback, useEffect, useState } from "react";
import { VERSAO_ATUAL } from "../data/novidades";

const STORAGE_KEY = "novidades_dispensada_versao";

/**
 * Controla a exibição do pop-up de novidades.
 *
 * Regra: o modal aparece SEMPRE (a cada login / acesso à listagem) até que o
 * usuário marque "não mostrar novamente". Ao marcar, guardamos a versão atual;
 * o pop-up só volta quando surgir uma versão nova em `NOVIDADES` (item novo).
 */
export function useNovidades() {
  const [aberto, setAberto] = useState(false);

  useEffect(() => {
    let dispensada: string | null = null;
    try {
      dispensada = localStorage.getItem(STORAGE_KEY);
    } catch {
      // Sem localStorage (aba privada, etc.) → mostra mesmo assim.
    }
    if (dispensada !== VERSAO_ATUAL) {
      setAberto(true);
    }
  }, []);

  /**
   * Fecha o modal. Se `naoMostrarNovamente` for true, marca a versão atual como
   * dispensada (não reaparece até uma nova versão).
   */
  const fechar = useCallback((naoMostrarNovamente: boolean) => {
    if (naoMostrarNovamente) {
      try {
        localStorage.setItem(STORAGE_KEY, VERSAO_ATUAL);
      } catch {
        // Ignora falha de persistência — no pior caso, reaparece na próxima vez.
      }
    }
    setAberto(false);
  }, []);

  return { aberto, fechar };
}
